module.exports = __webpack_public_path__ + "media/images/lb/503-135f5cf28219eda3ee6e66803a239ab3.svg";